import http from '@/plugins/axios';

export default {
  searchProduct(search) {
    const params = {
      search,
    };
    return http.get('products-with-groups', {
      params,
    });
  },
  getProductGroup(groupId) {
    const params = {
      group_id: groupId,
    };
    return http.get('product-group', {
      params,
    });
  },
  getProductGroups() {
    return http.get('product-groups');
  },
  createGroup(payload) {
    return http.post('create-product-group', {
      name: payload.name,
      products: payload.products,
    });
  },
  deleteGroup(groupId) {
    return http.post('delete-group', {
      group_id: groupId,
    });
  },
  editGroup(payload) {
    const data = {
      groupId: payload.groupId,
      products: payload.products,
    };
    return http.post('edit-product-group', data);
  },
  editGroupName(payload) {
    const data = {
      groupId: payload.groupId,
      name: payload.name,
    };
    return http.post('edit-product-group-name', data);
  },
  removeFromGroup(payload) {
    return http.post('remove-from-product-group', {
      groupId: payload.groupId,
      productId: payload.productId,
    });
  },
};
